import React, { createContext, useContext, useEffect, useState } from 'react';

const UsersContext = createContext();

export const useUsersContext = () => {
    const context = useContext(UsersContext);

    if (!context) {
        throw new Error('useUsers must be used within a UsersContext');
    }

    return context;
};

export const UsersProvider = ({ children, fetchUrl }) => {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        fetch();
    }, []);

    const fetch = () => {
        axios
            .get(fetchUrl)
            .then(({ data }) => {
                setUsers(data?.data || []);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const value = { fetch, users };

    return <UsersContext.Provider value={value}>{children}</UsersContext.Provider>;
};

export default UsersContext;
